import PropTypes from 'prop-types';

export default function IconWarning(props) {
    const { className, size = 48, color = '#FF7F5B' } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            viewBox="0 0 48 48"
            className={className}
        >
            <circle cx="24" cy="24" r="21" fill={color}></circle>
            <path
                fill="#fff"
                d="M22.277 16.931c.773-1.315 2.674-1.315 3.447 0l6.503 11.055c.785 1.333-.176 3.014-1.723 3.014H17.498c-1.547 0-2.51-1.681-1.725-3.014zm1.724 10.07a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-8a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1"
            ></path>
        </svg>
    );
}

IconWarning.propTypes = {
    className: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.string,
};
